import { ICenter } from "../../baseInfo/center/interfaces";
import { enmEvaluationStatus } from "../../baseInfo/damageCase/interfaces";
import { IEntity } from "../../components/infrastructure/models";

export enum enmContactStatus {
    Unacceptable = 0,
    Acceptable = 1,
    Failed = 2,
    EvaluationMethodToPolicyholderInPerson = 3
}

export interface IDamageCaseEvaluator extends IEntity {
    DamageCaseId: number;
    EvaluatorId: number;
    Evaluator: ICenter;
    Substatus: enmEvaluationStatus;
}
